import React from 'react'
import Link from '@/components/atoms/Link'

const NotificationBar = () => (
  <div id="notification-bar" sx={{ bg: '#002D54', textAlign: 'center', p: 3 }}>
    <p
      sx={{
        color: 'white',
        fontWeight: '400',
        fontFamily: 'sans',
        fontSize: 16,
      }}
    >
      <Link
        href="/extralife"
        sx={{
          color: 'white',
          // fontFamily: 'sans',
          // fontWeight: "bold",
          '&:hover': {
            color: 'contiYellow',
            textDecoration: 'underline',
          },
        }}
      >
        Thank you for all the support for <span className="font-bold">Extra Life 2025</span>!
      </Link>
    </p>
  </div>
)
export default NotificationBar
